"use client";

import {
  CARD_COLORS,
  CARD_COLOR_LABELS,
  CARD_COLOR_VAR,
  type CardColor,
} from "../tokens";

function cn(...parts: Array<string | false | null | undefined>): string {
  return parts.filter(Boolean).join(" ");
}

export function ColorPicker({
  value,
  onChange,
  allowNone = true,
  size = 26,
}: {
  value: CardColor | null;
  onChange: (v: CardColor | null) => void;
  allowNone?: boolean;
  size?: number;
}) {
  return (
    <div className="flex items-center gap-2.5">
      {CARD_COLORS.map((c) => {
        const selected = value === c;
        return (
          <button
            key={c}
            type="button"
            onClick={() => onChange(c)}
            aria-label={CARD_COLOR_LABELS[c]}
            aria-pressed={selected}
            title={CARD_COLOR_LABELS[c]}
            style={{
              background: CARD_COLOR_VAR[c],
              width: size,
              height: size,
            }}
            className={cn(
              "rounded-full transition outline-none",
              selected
                ? "ring-2 ring-[color:var(--color-ink)] ring-offset-2 ring-offset-[color:var(--color-surface)]"
                : "ring-1 ring-black/10",
            )}
          />
        );
      })}
      {allowNone && (
        <button
          type="button"
          onClick={() => onChange(null)}
          aria-label="No color"
          aria-pressed={value === null}
          title="No color"
          style={{
            width: size,
            height: size,
            background: "var(--color-beige-overlay)",
          }}
          className={cn(
            "rounded-full transition outline-none",
            value === null
              ? "ring-2 ring-[color:var(--color-ink)] ring-offset-2 ring-offset-[color:var(--color-surface)]"
              : "ring-1 ring-black/15",
          )}
        />
      )}
    </div>
  );
}
